import { CancelTokenSource } from 'axios'
import Agent from '../api/Agent'
import { IDisable } from '../models/Disable'
import { CurrentUserProfileRequest } from '../models/Enquiry'
import { IPasswordDTO, IPasswordUpdated } from '../models/Password'
import { IPinDTO } from '../models/Pin'
import {
  RegisterUserRequest,
  UserProfile,
  UserProfileRequest,
} from '../models/Profile'
import { INewUserEmail } from '../models/ChangeUserEmail'
import { UpdateUserAbnRequest } from '../models/ChnageABN'
import { InitiateMFAPhoneChange, NewMFAPhone } from '../models/ChangeMFAPhone'

class ProfileService {
  getCurrentUserProfile = async (source: CancelTokenSource) => {
    return await Agent.Profiles.getCurrentUserProfile(source)
  }

  getUpdateUserViewModel = async (source: CancelTokenSource) => {
    return await Agent.Profiles.getUpdateUserViewModel(source)
  }

  createUserProfile = async (userProfile: UserProfile) => {
    const payload = new RegisterUserRequest(userProfile)
    return Agent.Profiles.createUserProfile(payload)
  }

  updateUserProfile = async (userProfile: UserProfile) => {
    const payload = new UserProfileRequest(userProfile)
    return Agent.Profiles.updateUserProfile(payload)
  }

  resetPin = async (pin: IPinDTO) => {
    return Agent.Profiles.resetPin(pin)
  }
  disableUser = async (disableUser: IDisable) => {
    return Agent.Profiles.disableUser(disableUser)
  }
  resetPassword = async (passwords: IPasswordDTO) => {
    return Agent.Profiles.resetPassword(passwords)
  }

  updateCurrentUserProfile = async (userProfile: CurrentUserProfileRequest) => {
    return Agent.Profiles.updateCurrentUserProfile(userProfile)
  }

  passwordUpdated = async (passwordUpdated: IPasswordUpdated) => {
    return Agent.Profiles.passwordUpdated(passwordUpdated)
  }
  changePhoneNumber = async (source: CancelTokenSource) => {
    return await Agent.Profiles.changePhoneNumber(source)
  }
  changeUserEmail = async (emailToChange: INewUserEmail) => {
    return await Agent.Profiles.changeUserEmail(emailToChange)
  }

  recordLoginDate = async (source: CancelTokenSource) => {
    return await Agent.Profiles.recordLoginDate(source)
  }
  changeABN = async (abnToChange: UpdateUserAbnRequest) => {
    return await Agent.Profiles.changeABN(abnToChange)
  }
  initiateMFAPhoneChange = async (
    initiateMFAPhoneChane: InitiateMFAPhoneChange
  ) => {
    return await Agent.Profiles.initiateMFAPhoneChange(initiateMFAPhoneChane)
  }
  changeMFAPhone = async (mfaToChange: NewMFAPhone) => {
    return await Agent.Profiles.changeMFAPhone(mfaToChange)
  }
}

export default new ProfileService()
